import React, { useState } from 'react';
//import {useNavigate} from 'react-router-dom'
import {ID} from '@/_metronic/helpers'
import {useListView} from '@/components/table/core/ListViewProvider'
import {useQueryResponse} from '@/components/table/core/QueryResponseProvider'
import {SupplierOperation, OpProduct} from '../../core/_models'
import {splitBulkOrder} from '../../core/_requests'

const SplitForm = () => {
  // const navigate = useNavigate()
  const {itemForUpdate, setItemForUpdate, setAction} = useListView();
  const {refetch} = useQueryResponse()
  const order = itemForUpdate as SupplierOperation;
  const [parts, setParts] = useState<ID[]>([]);
  const [processing, setProcessing] = useState<boolean>(false);

  const handleSplit = (id: ID, checked: boolean) => {
    setParts(prev =>
      checked ? [...prev, id] : prev.filter(item => item !== id)
    );
  };

  const split = async () => {
    try {
      setProcessing(true);
      await splitBulkOrder(order?._id, parts)
      close();
      refetch();
    } catch (e: unknown) {
      console.log(e)
    } finally {
      setProcessing(false);
    }
  }

  const close = () => {
    setAction(undefined);
    setItemForUpdate(undefined);
    setParts([]);
  }

  return (
    <>
      <p className='text-danger fw-bolder'>
        Select products to split
      </p>

      <table className="table table-rounded table-striped border gy-4 gs-4">
        <thead>
          <tr className="border-bottom fs-6 fw-bold text-muted">
            <th className="max-w-30px"></th>
            <th className="min-w-175px pb-2">Product</th>
            <th className="w-125px text-start pb-2">Qty</th>
            <th className="min-w-100px text-end pb-2">Total amount</th>
          </tr>
        </thead>
        <tbody>
          {order.products?.map((p: OpProduct, index: number) => (
            <tr key={`product-${index}`}>
              <td className="w-30px">
                <div className="form-check form-check-custom form-check-solid">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value={p.product?.toString()}
                    onChange={e => handleSplit(p.product, e.target.checked)}
                  />
                </div>
              </td>

              <td className="text-start">{p.name}</td>
              <td className="text-start">{p.qty}</td>
              <td className="text-end">
                { (p.amount * (100 - p.discount) / 100 * p.qty).toFixed(2) }
              </td>
            </tr>
          ))}
          <tr>
            <td className="text-start fw-bold" colSpan={2}>{order.products?.length} products</td>
            <td className="text-start fw-bold">
              {order.products?.reduce((acc: number, p: OpProduct) => {
                return acc + p.qty
              }, 0)}
            </td>
            <td className="text-end fw-bold">
              {order.products?.reduce((acc: number, p: OpProduct) => {
                return acc + Number((p.amount * (100 - p.discount) / 100 * p.qty).toFixed(2));
              }, 0)}
            </td>
          </tr>
        </tbody>
      </table>

      {parts.length > 0 && (
        <>
          <p className="text-danger fw-bolder">Selected: {parts.length}</p>
          <p className="">
            {parts.map(_ => {
              return (order?.products || []).find(x => x?.product === _)?.name || ''
            }).join(', ')}
          </p>
        </>
      )}
      <div className="mt-5 text-end">
        <button
          className="btn btn-light me-3"
          type="button"
          onClick={close}
        >
          Cancel
        </button>

        <button
          className="btn btn-danger ms-5"
          type="button"
          onClick={split}
          disabled={parts.length === 0  || processing}
        >
          Confirm split
        </button>

      </div>
    </>
  )
}

export default SplitForm;
